import { ErrorMessagesInterface } from '../interfaces';

export const ErrorMessages: ErrorMessagesInterface = {
  NO_SELECTED_APPLICATION: 'No selected application',
  INVALID_APPLICATION_TYPE: 'Invalid Application type',
  NO_ANALYSIS_NAME: 'Analysis Name not present',
  NO_REDIRECT_URL: 'Redirect URL not present',
  NO_NOTEBOOK_CONFIG: 'Notebook Config is required',
  NO_WORKSPACE_OR_ANALYSIS_NAME: 'Workspace or Analysis name not present',
  NO_INCLUDED_DATA: 'No included data present in response',
  NO_SELF_LINK: 'No Self URL present',
};
